import React from 'react';
import PropTypes from 'prop-types';
import './FormUploadField.scss';
import FileUpload from '../common/FileUpload';

const provideFile = delegate => file => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => delegate({ name: file.name, data: reader.result });
};

const FormFileField = ({
  input,
}) => {
  return (
    <FileUpload onFilePicked={provideFile(input.onChange)} file={input.value ? input.value : null} />
  );
};

FormFileField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
};

export default FormFileField;



// WEBPACK FOOTER //
// ./src/components/form/FormFileField.js